import rest from 'lib/rest';
import React, { useEffect, useState } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  Input,
  CardHeader,
  CardTitle,
  CardBody,
  Button,
  UncontrolledCollapse,
  InputGroup,
  InputGroupAddon
} from "reactstrap"
import rotas from 'services/rotas';
import settings from 'settings';
import Swal from 'sweetalert2';

import useForm from 'lib/useForm';
import RelatorioFiltro from './RelatorioFiltro'
import "./style.css";

const inicialForm = {
  pesquisa : ''
}

const Relatorio = () => {

  const [popoverOpen, setPopoverOpen] = useState(false);
  const [listaRelatorios, setListaRelatorios] = useState([]);
  const [listaRelatorios_aux, setListaRelatorios_aux] = useState([]);
  const [paramRelatorio, setParamRelatorio] = useState({});
  const [btnExcluir, setBtnExcluir] = useState('');
  const [favoritos, setFavoritos] = useState([]);
  const [form, onChange] = useForm(inicialForm);

  useEffect(() => {
    listarRelatorios();
    carregarFavoritos();
  }, [])

  const carregarFavoritos = () => {
    const url     = settings.url + rotas.relatorioFavoritos;
    const retorno = rest.get(url);
    retorno.then(ret => {
      if (ret.success === 'S') {
        setFavoritos(ret.lista.map(id => parseInt(id)));
      }
    });
  }

  const toggleFavorito = (e, relatorio_id) => {
    e.stopPropagation();
    const baseUrl = settings.url + rotas.relatorioFavoritos;
    const isFav   = favoritos.includes(relatorio_id);
    const requisicao = isFav
      ? rest.del(baseUrl + '?relatorio_id=' + relatorio_id)
      : rest.post(baseUrl, { relatorio_id });

    requisicao.then(ret => {
      if (ret.success === 'S') {
        setFavoritos(prev =>
          isFav ? prev.filter(id => id !== relatorio_id) : [...prev, relatorio_id]
        );
      }
    });
  }

  const ContextParametros = React.createContext(paramRelatorio);

  const listarRelatorios = () => {

    const url     = settings.url + rotas.listarRelatorios;
    const retorno = rest.get(url);

    retorno.then(ret => {
      if (ret.success === 'S') {
        let relat = [];
        ret.lista.forEach(r => {
          r.selecionado = 'N';
          relat.push(r);
        })
        setListaRelatorios(relat);
        setListaRelatorios_aux(ret.lista);
      } else {
        Swal.fire('Erro', ret.msg, 'error');
      }
    })
  }

  const selecionaRelatorio = (relatorio) => {
    const lRelat = listaRelatorios;

    lRelat.forEach(rel => {
      rel.relatorios.forEach(r => {
        if(r.relatorio_id === relatorio.relatorio_id){
          r.selecionado = 'S';
        }else{
          r.selecionado = 'N';
        }
      })
    })
    setListaRelatorios(lRelat);
    setParamRelatorio(relatorio);
  }

  const limpaPesquisa = () => {
    setListaRelatorios(listaRelatorios_aux);
    setBtnExcluir('')
    form.pesquisa = ''
  }

  const pesquisaRelat = (evt) => {
    evt.preventDefault()

    setBtnExcluir(
      <InputGroupAddon addonType="append" key="inGrpAddon">
      <Button
        key       = "btnExcluir"
        className = 'm-0'
        color     = 'primary'
        onClick   = {limpaPesquisa}
      >
        <i className="fas fa-close"></i>
      </Button>
      </InputGroupAddon>
    )

    if (listaRelatorios_aux.length === 0) {
      setListaRelatorios_aux(listaRelatorios);
    }

    let rt_pesquisa = []

    listaRelatorios_aux.forEach(lista => {
      lista.relatorios.forEach(el => {
        const result = el.nome_relatorio.toLowerCase().indexOf(form.pesquisa.toLowerCase()) >= 0
        if (result) {
          rt_pesquisa.push(el)
        }
      })
    })

    var listaPesquisa = [{tipo: 'Pesquisa', subtipo: 'Pesquisa', relatorios: rt_pesquisa, aberto:'true'},]

    setListaRelatorios(listaPesquisa)
  }

  return (
    <>
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                  <Col>
                    <CardTitle>RELATÓRIOS</CardTitle>
                  </Col>

                  <Col>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <Button
                        title     = "Pesquisar Relatórios"
                        className = 'm-0'
                        color     = "success"
                        onClick   = {pesquisaRelat}
                      >
                        <i className="fas fa-search"></i>
                      </Button>
                    </InputGroupAddon>
                    <Input
                      id          = "pesquisa"
                      name        = "pesquisa"
                      type        = "text"
                      placeholder = "Pesquisar Relatório"
                      value       = {form.pesquisa}
                      onChange    = {onChange('pesquisa')}
                      onKeyPress = {e => {
                        if (e.key === 'Enter') {
                          e.preventDefault()
                          pesquisaRelat(e)
                        }
                      }}
                    />

                      {btnExcluir}
                      
                  </InputGroup>
                  </Col>
                  </Row>

                  {/* <Button
                    className="btn-round m-0 pesquisarRelatorio"
                    id="Popover1"
                    color="primary"
                    size="sm"
                    title="Pesquisar Relatórios"
                    outline
                    onClick = {limpaPesquisa}
                    >
                    <i className="fas fa-search" />
                  </Button> */}

                  {/* <Popover
                    placement="bottom"
                    isOpen={popoverOpen}
                    target="Popover1"
                    toggle={toggle}
                  >
                    <PopoverHeader className="text-center">PESQUISAR RELATÓRIOS</PopoverHeader>
                    <PopoverBody>
                      <Form id="form-pesquisa" inline onSubmit={pesquisaRelat}>
                        <FormGroup className="mb-2 mr-sm-2 mb-sm-0 w-100">
                          <Input
                            className="rounded-0 w-100"
                            type="text"
                            name="pesquisa"
                            id="pesquisa"
                            placeholder="Digite a palavra chave"
                            value       = {form.pesquisa}
                            onChange    = {onChange('pesquisa')}
                          />
                        </FormGroup>
                        <Button
                          className="rounded-0 w-100"
                          size="sm"
                          type="submit"
                          color="success"
                        >
                          Pesquisar
                        </Button>
                      </Form>
                    </PopoverBody>
                  </Popover> */}
                </CardHeader>

                <CardBody>
                  <Row>
                    {/* RELATÓRIOS */}
                    <Col
                      md        = "6"
                      className = "border-right"
                      style     = {{overflowY: 'scroll',overflowX: 'hidden', maxHeight: '600px'}}
                    >
                      {/* FAVORITOS */}
                      {favoritos.length > 0 && (() => {
                        const relatsFav = [];
                        listaRelatorios_aux.forEach(cat => {
                          cat.relatorios && cat.relatorios.forEach(r => {
                            if (favoritos.includes(parseInt(r.relatorio_id))) {
                              relatsFav.push(r);
                            }
                          });
                        });
                        return relatsFav.length > 0 ? (
                          <div key="divkeyFavoritos">
                            <Button
                              block
                              id        = "relatoriosFavoritos"
                              color     = "warning"
                              size      = "md"
                              className = "botaoCategoriaR"
                            >
                              <span className="btn-label">
                                <i className="fas fa-star"></i>
                                {' '}Favoritos
                              </span>
                            </Button>
                            <UncontrolledCollapse toggler="#relatoriosFavoritos" defaultOpen={true}>
                              <Col className="border p-3">
                                {relatsFav.map((relat, key) =>
                                  <Button
                                    outline block
                                    key       = {'relatorioFavKey'+key}
                                    className = "botaoRelatorio"
                                    color     = {relat.selecionado === 'S' ? "primary" : "default"}
                                    size      = "sm"
                                    onClick   = {() => { selecionaRelatorio(relat) }}
                                  >
                                    <i
                                      className = "fas fa-star"
                                      style     = {{color: '#f5a623', marginRight: '6px', cursor: 'pointer'}}
                                      onClick   = {(e) => toggleFavorito(e, parseInt(relat.relatorio_id))}
                                    ></i>
                                    {relat.nome_relatorio}
                                  </Button>
                                )}
                              </Col>
                            </UncontrolledCollapse>
                          </div>
                        ) : null;
                      })()}

                      {/* CATEGORIAS */}
                      {listaRelatorios.map((relatorio, index) =>
                        <div key={"divkey"+relatorio.tipo+index}>
                          <Button
                            block
                            id        = {"relatorios" + relatorio.tipo}
                            key       = {'relatorioKey'+relatorio.tipo+index}
                            color     = "info"
                            size      = "md"
                            className = "botaoCategoriaR"
                          >
                            <span className="btn-label">
                              <i className="nc-icon nc-money-coins"></i>
                              {relatorio.tipo}
                            </span>
                          </Button>
                          <UncontrolledCollapse
                            key     = {'relatorioCollKey'+relatorio.tipo+index}
                            toggler = {"#relatorios" + relatorio.tipo}
                          >
                            <Col key={'relatorioCollKeyCol'+relatorio.tipo+index} className="border p-3">
                              {relatorio.relatorios.map((relat, key) =>
                                <Button
                                  outline block
                                  key       = {'relatorioSubKey'+index+key}
                                  className = "botaoRelatorio"
                                  color     = {relat.selecionado === 'S' ? "primary" : "default"}
                                  size      = "sm"
                                  onClick   = {() => { selecionaRelatorio(relat) }}
                                >
                                  <i
                                    className = {favoritos.includes(parseInt(relat.relatorio_id)) ? "fas fa-star" : "far fa-star"}
                                    style     = {{color: '#f5a623', marginRight: '6px', cursor: 'pointer'}}
                                    onClick   = {(e) => toggleFavorito(e, parseInt(relat.relatorio_id))}
                                  ></i>
                                  {relat.nome_relatorio}
                                </Button>
                              )}
                            </Col>
                          </UncontrolledCollapse>
                        </div>
                      )}

                      {/* ESTOQUE */}
                      {/* <Button color="info" id="relatoriosEstoque" size="md" className="botaoCategoriaR" block><span class="btn-label"><i class="nc-icon nc-box-2"></i></span>ESTOQUE</Button>
                        <UncontrolledCollapse toggler="#relatoriosEstoque">
                          <Col className="border p-3">
                            <Button className="botaoRelatorio" color="default" size="sm" outline block>Nome do relatório</Button>
                          </Col>
                        </UncontrolledCollapse> */}

                      {/* CLIENTES */}
                      {/* <Button color="info" id="relatoriosClientes" size="md" className="botaoCategoriaR" block><span class="btn-label"><i class="nc-icon nc-single-02"></i></span>CLIENTES</Button>
                        <UncontrolledCollapse toggler="#relatoriosClientes">
                          <Col className="border p-3">
                            <Button className="botaoRelatorio" color="default" size="sm" outline block>Nome do relatório</Button>
                          </Col>
                        </UncontrolledCollapse> */}

                      {/* FISCAL */}
                      {/* <Button color="info" id="relatoriosFiscal" size="md" className="botaoCategoriaR" block><span class="btn-label"><i class="nc-icon nc-chart-pie-36"></i></span>FISCAL</Button>
                        <UncontrolledCollapse toggler="#relatoriosFiscal">
                          <Col className="border p-3">
                            <Button className="botaoRelatorio" color="default" size="sm" outline block>Nome do relatório</Button>
                          </Col>
                        </UncontrolledCollapse> */}
                    </Col>

                    {/* FILTROS */}
                    <Col md="6">
                      <ContextParametros.Provider value={paramRelatorio}>
                        <ContextParametros.Consumer>
                          {(relatorio) => (
                            <RelatorioFiltro paramRelatorio={relatorio}>
                            </RelatorioFiltro>
                          )}
                        </ContextParametros.Consumer>
                      </ContextParametros.Provider>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default Relatorio;
